import React, { Component } from 'react';

import { connect } from 'react-redux';
//import './Admin.css';
import AdminTable from './adminTable/adminTable.js';
import { userActions } from '../../actions/index.js';
//import AdminModal from './admin-modal-popup/admin-modal';
//import { userActions } from '../actions';
// import { connect } from "react-redux";
import { withRouter } from "react-router-dom"; 

class Admin extends Component {

    constructor(props) {
        super(props);

        this.state = {
            auditorUser:[]
        };

        this.submitHandler = this.submitHandler.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.paginationHandler=this.paginationHandler.bind(this);
    }
   componentWillMount(){
       const reqBody={
           "size":10,
           "index":0,
           "sortColumn":"userId",
           "sortOrder":"ASC"
       }
       console.log('ComponentWillMount');
       this.setState({ auditorUser: [] });
     this.props.dispatch(userActions.auditorList("/auditorData/auditors",reqBody));
       console.log('AdminProps:',this.props);
   }
   paginationHandler(pageNumber, pageSize, sortColumnName, sortOrder) {
    const {dispatch}=this.props;
    const reqBody={
        "size":pageSize ? pageSize:10,
        "index":pageNumber-1,
        "sortColumn":sortColumnName,
        "sortOrder":sortOrder
      }
      dispatch(userActions.auditorList("/auditorData/auditors",reqBody))
   }
    changeHandler(e) {

    }

    submitHandler(e) {

    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.auditorUser) {
            this.setState({ auditorUser: nextProps.auditorUser});
        }
        
    }
    render() {
        console.log('AdminRender:',this.props);
        return (
            <div>
                <h3 style={{textAlign:"center"}}>Auditor Set Up</h3>
                <AdminTable
                 auditorData={this.props.auditorUser}
                 paginationHandler={this.paginationHandler}
                 />
            </div>
        )
    }
}

const mapStateToProps = state =>{
   console.log('AuditorReducer:',state.searchData);
    const {auditorUser,blocking} =state.searchData;
    return{
        auditorUser,blocking
    }
    
}
export default withRouter(connect(mapStateToProps)(Admin)); 